import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { IoIosArrowUp } from 'react-icons/io'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const StyledBtnScrollToTop = styled.button`
  padding: 5px;
  position: fixed;
  right: 0;
  bottom: 20px;
  background-color: #b1b1b1;
  border: none;
  border-radius: 5px;
  z-index: 11;
  opacity: ${(p) => (p.$visible ? 1 : 0)};
  transition: opacity 0.3s ease;
  pointer-events: ${(p) => (p.$visible ? 'auto' : 'none')};
`

const ScrollToTop = () => {
  const { pathname } = useLocation()
  const [visible, setVisible] = useState(false)
  const { t } = useTranslation()

  const isPersonalProducts = /^\/products\/personal(\/|$)/i.test(pathname)
  const isNarrow = typeof window !== 'undefined' && window.innerWidth <= 1080

  const scrollWindowTop = useCallback(() => {
    if (typeof window === 'undefined') return
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const hasNonEmptyCategories = useCallback(() => {
    const el = document.getElementById('catalogCategories')
    if (!el) return false
    // check if there is at least one visible child or <li>
    return el.querySelector('li, [data-category-id], .category-item') !== null
  }, [])

  // const scrollPersonalTop = useCallback(() => {
  //   // Try our explicit anchor first, then fallbacks
  //   const el =
  //     document.querySelector('#personalProductsTop') ||
  //     document.querySelector('[data-products-top]') ||
  //     document.querySelector('[data-category-tree]')

  //   if (el) {
  //     el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  //   } else {
  //     // fallback to page top
  //     scrollWindowTop()
  //   }
  // }, [scrollWindowTop])
  const scrollCategories = useCallback(() => {
    const el = document.getElementById('catalogCategories')
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    } else {
      scrollWindowTop()
    }
  }, [scrollWindowTop])

  const toggleVisibility = useCallback(() => {
    const y =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0
    setVisible(y > 150)
  }, [])

  useEffect(() => {
    toggleVisibility()
    window.addEventListener('scroll', toggleVisibility)
    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [toggleVisibility])

  const canScrollToCategories =
    isPersonalProducts && isNarrow && hasNonEmptyCategories()

  const label = canScrollToCategories
    ? t('header:scrollToList')
    : t('header:scrollToTop')

  const onClick = canScrollToCategories ? scrollCategories : scrollWindowTop

  return (
    <div className='d-flex justify-content-start align-items-center'>
      <StyledBtnScrollToTop
        className='no-border-radius'
        onClick={onClick}
        title={label}
        aria-label={label}
        $visible={visible}
      >
        <IoIosArrowUp size='23' className='text-white' />
      </StyledBtnScrollToTop>
    </div>
  )
}

export default ScrollToTop
